export default {
  share: {
    title: '分享就送优惠券，申请货架更有200元充值大礼哦～',
    desc: '便利蜂无人货架“蜂”狂来袭办公室，零食饮料、鲜食水果，触手可及',
    imageUrl: `${location.origin}/jack/static/img/minishare-logo.png`,
    imageWxUrl: 'https://s.blibee.net/res/blibee-app/image/shelves/share-logo.png',
    linkUrl: `${location.origin}/jack/pages/application/index.html`,
  },
};



// WEBPACK FOOTER //
// ./src/pages/Application/config.js